import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/projectBuildInfo/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/projectBuildInfo/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/projectBuildInfo/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/projectBuildInfo/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/projectBuildInfo/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
